import { toast } from "sonner";
import { ApiResponse } from "../types/responseType";
import customFetch from "../util/config/axiosConfig";
import {
  Assignment,
  AssignmentPage,
  createAssignment,
} from "../types/assignmentType";
import { getErrorMessage } from "../util/functions/UniversalFunctions";

const assignmentApis = {
  // GET all
  getAssignments: async (params: {
    branchCode: string;
    page: number;
    size: number;
    filters?: Record<string, any>;
  }): Promise<ApiResponse<AssignmentPage>> => {
    const { filters, ...rest } = params;

    const response = await customFetch.get<ApiResponse<AssignmentPage>>(
      "/assignment/filter",
      {
        params: {
          ...rest,
          ...(filters || {}),
        },
      },
    );

    return response.data;
  },

  // POST
  createAssignment: async (
    payload: createAssignment,
  ): Promise<ApiResponse<createAssignment> | undefined> => {
    try {
      const response = await customFetch.post<ApiResponse<createAssignment>>(
        "/assignment",
        payload,
      );

      toast.success("assignment created successfully");
      return response.data;
    } catch (error: any) {
      const message = getErrorMessage(error);
      toast.error(message);
      console.error("Error creating admission:", error);
    }
  },

  // GET BY ID
  getAssignmentById: async (
    assignmentId: string,
  ): Promise<ApiResponse<Assignment> | undefined> => {
    try {
      const response = await customFetch.get<ApiResponse<Assignment>>(
        `/assignment/${assignmentId}`,
      );
      return response.data;
    } catch (error: any) {
      toast.error(error?.response?.data?.error || "Failed to fetch assignment");
      console.error("Error fetching assignment:", error);
    }
  },

  // DELETE
  deleteAssignment: async (assignmentId: string) => {
    try {
      const response = await customFetch.delete(`/assignment/${assignmentId}`);
      toast.success("Assignmentt deleted successfully");
      return response.data;
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message || "Failed to delete assignment",
      );
      return;
    }
  },

  // Update Assignment
  updateAssignment: async ({
    assignmentId,
    payload,
  }: {
    assignmentId: string;
    payload: createAssignment;
  }): Promise<ApiResponse<createAssignment> | undefined> => {
    try {
      const response = await customFetch.put<ApiResponse<createAssignment>>(
        `/assignment/${assignmentId}`,
        payload,
      );

      toast.success("Assignment updated successfully");
      return response.data;
    } catch (error: any) {
      const message = getErrorMessage(error);
      toast.error(message);
      console.error("Error updating assignment:", error);
    }
  },
};

export default assignmentApis;
